import React, { useEffect, useState, useCallback } from "react";
import { loadStripe, Stripe, StripeElements } from "@stripe/stripe-js";
import { CardNumberElement } from "@stripe/react-stripe-js";
import PageWrapper from "../SignupPages/PageWrapper";
// import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";
import "../SupplementCheckout/SupplementCheckout.css";
import {
  getStripeProducts,
  submitIntakeForm,
  updateExistingPatient,
  validateCoupon,
} from "../../services/api";
import { useNavigate } from "react-router-dom";
import CheckoutFormWrapper from "../../components/CheckoutForm/CheckoutFormWrapper";
import AntiAging from "../../assets/images/anti-aging.png";
import BoostEnergy from "../../assets/images/boost-energy.png";
import ClearBrain from "../../assets/images/clear-brain-fog.png";
import ImproveAthletic from "../../assets/images/improve-athletic.png";
import ImproveMentalClarity from "../../assets/images/improve-mental-clarity.png";
import MemoryConcentration from "../../assets/images/memory-concentration.png";
import MetabolicFunction from "../../assets/images/metabolic-function.png";
import couponImage from "../../assets/images/couponIcon.png";
import NadPlusNasalInjectables from "../../assets/images/nadplus-injectables.png";
import "../NadPlusPages/NadPlusCommon.css";

interface PricingItem {
  id: string;
  unit_amount: number;
  product: string;
}

interface Product {
  type: string;
  active: boolean;
  recurring: {
    interval_count: number;
  };
  unit_amount: number;
  id: string;
  name: string;
  price: number;
  // etc.
}

declare global {
  interface Window {
    EF?: {
      click: (params: {
        offer_id: string | null;
        affiliate_id?: string | null;
        sub1?: string | null;
        sub2?: string | null;
        sub3?: string | null;
        sub4?: string | null;
        sub5?: string | null;
        uid?: string | null;
        source_id?: string | null;
        transaction_id?: string | null;
      }) => void;
      conversion: (params: {
        offer_id: number;
        amount?: number;
        affiliate_id?: string;
      }) => void;
    };
    fbq: (...args: any[]) => void;
  }
}

const isProd = process.env.REACT_APP_ENV === "production";
const key = isProd
  ? "pk_live_51PsWA5GejApNyv7Xuy48c50fEyWxIqSglHCR33zJQNzXYUG4DHu4hpbRM80SVkXNrSPgimj1ioe3cVabLPjgN3bh00GkcYUa3H"
  : "pk_test_51PsWA5GejApNyv7Xdo7ye2sTXDMhrfaFsd15JKinSzBWaSR3iqAwTgEkbm9ZCPzit4RpxVotpvaPScTPiwwjG1ht00qiPluAWx";
const stripePromise = loadStripe(key);

const SYNC_STATES = ["DC", "DE", "MS", "NM", "RI", "WV"];

const SermorelinPage14 = () => {
  const [formState, setFormState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
    billingAddressAddressLine1: "",
    billingAddressAddressLine2: "",
    billingAddressCity: "",
    billingAddressState: "",
    billingAddressZip: "",
    country: "",
    postcode: "",
    isCheckedTerms: false,
    firstNameError: "",
    lastNameError: "",
    emailError: "",
    phoneError: "",
    addressLine1Error: "",
    cityError: "",
    stateError: "",
    zipError: "",
    billingAddressAddressLine1Error: "",
    billingAddressCityError: "",
    billingAddressStateError: "",
    billingAddressZipError: "",
    isSubscribed: false,
    isChecked: false,
    isVariant: localStorage.getItem("isVariant") === "true",
    disableAddress: false,
    isCardValid: false,
    error: "", // Added for displaying general errors
    loading: false,
  });
  const navigate = useNavigate();
  const [isCardNumberValid, setIsCardNumberValid] = useState(false);
  const [isCardExpiryValid, setIsCardExpiryValid] = useState(false);
  const [isCardCvcValid, setIsCardCvcValid] = useState(false);
  const isCardValid = isCardNumberValid && isCardExpiryValid && isCardCvcValid;
  const [finalAmount, setFinalAmount] = useState<number | null>(0);
  const [basePriceAfterDefaultDiscount, setBasePriceAfterDefaultDiscount] =
    useState<number | null>(0); // New state for base price
  const [showCouponInput, setShowCouponInput] = useState(false);
  const [loading1, setLoading1] = useState(false); // For coupon loading
  const [couponCode, setCouponCode] = useState<string>("");
  const [isCouponApplied, setIsCouponApplied] = useState<boolean>(false);
  const [wrongCoupon, setWrongCoupon] = useState<boolean>(false);
  const [showDiscountlabel, setShowDiscountLabel] = useState(false);
  const [couponDiscountValue, setCouponDiscountValue] = useState<number | null>(
    null
  );
  const [dob, setDob] = useState<string>("");
  const [gender, setGender] = useState<string>("");
  const [actualWeight, setActuralWeight] = useState<string>("");
  const [height, setHeight] = useState<string>("");
  const [stripeInstance, setStripeInstance] = useState<Stripe | null>(null);
  const [elementsInstance, setElementsInstance] =
    useState<StripeElements | null>(null);
  const [pricingData, setPricingData] = useState<PricingItem[]>([]);
  const [uuidValue, setUuidValue] = useState<string>("");

  const everflowConversion = () => {
    const script = document.createElement("script");
    const eFconversionCodeExecuted = window.localStorage.getItem(
      "EFconversionCodeExecuted"
    );
    script.src = "https://www.sffpl8trk.com/scripts/sdk/everflow.js";
    script.type = "text/javascript";
    script.async = true;
    script.onload = () => {
      
      if (window.EF && eFconversionCodeExecuted !== "true") {
        window.EF.conversion({
          offer_id: parseInt(localStorage.getItem("offer_id") || ""),
          affiliate_id: localStorage.getItem("affiliate_id") || "",
          amount: finalAmount ? finalAmount : undefined,
        });
        console.log("Sending conversion with:" ,{
          offer_id: parseInt(localStorage.getItem("offer_id") || ""),
          affiliate_id: localStorage.getItem("affiliate_id") || "",
          amount: finalAmount ? finalAmount : undefined,
        })
        window.localStorage.setItem("EFconversionCodeExecuted", "true");
        window.fbq("track", "Purchase", { currency: "USD", value: finalAmount });
      } else {
        console.warn("Everflow SDK failed to load.");
      }
    };
    document.body.appendChild(script);
  };

  const pushPurchaseEvent = (
    itemName: string,
    medicationType: string,
    price: string,
    planSelected: string,
    transactionID: string,
  ) => {
    if (localStorage.getItem("GTMPurchaseEventFired")) {
      return;
    } else {
      const key = `${itemName.toLowerCase()}-${medicationType.toLowerCase()}`;
        const itemIdMap: Record<string, number> = {
          "sermorelin-injectables": 7,
        };
      
        const itemId = itemIdMap[key];
        if (!itemId) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: transactionID,
          value: price,
          currency: "USD",
          items: [
            {
              item_id: itemId,
              item_name: `${itemName}-${medicationType}`,
              price: price,
              quantity: 1,
              plan_selected: planSelected,
            },
          ],
        },
      });
      localStorage.setItem("GTMPurchaseEventFired", "true");
      localStorage.setItem("GTMPurchaseEventTimestamp", Date.now().toString());
    }
  };

  const [formData, setFormData] = useState({
    mwl_modality: "async_visit", 
    visit_type: "initial",
    service_type:"NAD_Sermorelin",
    preferred_medication: "Sermorelin Injectable",
    first_name: "",
    last_name: "",
    dob: "",
    gender: "",
    height: "",
    email: "",
    email_subscribed: false,
    phone_number: "",
    state: "",
    uuid: "",
    weight: "",
    zip: "",
    line1: "",
    line2: "",
    city: "",
    Are_you_currently_or_planning_for_any_of_the_following: "",
    Do_you_have_a_history_of_active_suspected_or_prior_cancer_of_any_kind: "",
    Have_you_had_a_general_health_check_up_or_routine_physical_in_the_past_3_years:
      "",
    Do_you_have_any_allergies_or_sensitivities_to_Sermorelin: "",
    Do_you_have_untreated_hypothyroidism: "",
    Do_you_have_existing_uncontrolled_diabetes_with_a_hemoglobin_A1C_greater_than_9_percent: "",
    Do_you_use_opiate_medications_routinely_or_binge_drink_alcohol: "",
    What_are_your_primary_goals_for_seeking_treatment: "",
    Please_list_your_current_medications_prescription_and_over_the_counter_and_supplements:
      "",
    Do_you_have_any_one_of_the_following_medical_conditions: "",
  });

  const formatPhoneNumber = useCallback((value: string): string => {
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.length <= 3) return `(${cleaned}`;
    if (cleaned.length <= 6)
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6,
      10
    )}`;
  }, []);

  useEffect(() => {
    const retrieveLocalStorageData = () => {
      const getItemValue = (key: string) => {
        const item = localStorage.getItem(key);
        try {
          return item ? JSON.parse(item).value : "";
        } catch (e) {
          return item || "";
        }
      };

      setFormState((prev) => {
        const newState = {
          ...prev,
          firstName: getItemValue("firstName"),
          lastName: getItemValue("lastName"),
          email: getItemValue("email"),
          phone: formatPhoneNumber(getItemValue("phone")),
          isSubscribed: getItemValue("isSubscribed"),
        };

        newState.disableAddress = getItemValue("disable_address");
        newState.addressLine1 = getItemValue("addressLine1");
        newState.addressLine2 = getItemValue("addressLine2");
        newState.city = getItemValue("city");
        newState.state = getItemValue("state");
        newState.zip = getItemValue("zip");

        return newState;
      });

      // Other relevant states (dob, gender, etc.)
      setActuralWeight(getItemValue("weight"));
      setHeight(getItemValue("height"));
      setDob(getItemValue("dob"));
      setGender(getItemValue("gender"));
      setUuidValue(getItemValue("uuid"));
    };

    retrieveLocalStorageData();
  }, []);

  useEffect(() => {
    const retrieveLocalStorageData = () => {
      const getItem = (key: string) => {
        const item = localStorage.getItem(key);
        try {
          return item ? JSON.parse(item) : "";
        } catch (e) {
          return item || "";
        }
      };

      const userState = formState.state?.toUpperCase() || "";
      const isSyncState = SYNC_STATES.includes(userState);
      const mwlModality = isSyncState ? "sync_visit" : "async_visit"
      localStorage.setItem("mwl_modality", mwlModality);
  

      // Set form state for address and medical fields
      setFormData((prev) => {
        return {
          ...prev,
          mwl_modality: isSyncState ? "sync_visit" : "async_visit",
          first_name: formState.firstName,
          last_name: formState.lastName,
          dob: dob,
          gender: gender,
          weight: actualWeight,
          height: height,
          email: formState.email,
          phone_number: formState.phone,
          email_subscribed: formState.isSubscribed,
          uuid: uuidValue,
          line1: formState.addressLine1,
          line2: formState.addressLine2,
          city: formState.city,
          state: formState.state,
          zip: formState.zip,
          Are_you_currently_or_planning_for_any_of_the_following:
            getItem("isPlanningBaby")?.value || "",
          Do_you_have_a_history_of_active_suspected_or_prior_cancer_of_any_kind:
            getItem(
              "Do_you_have_a_history_of_active_suspected_or_prior_cancer_of_any_kind"
            )?.value,
          Have_you_had_a_general_health_check_up_or_routine_physical_in_the_past_3_years:
            getItem(
              "Have_you_had_a_general_health_check_up_or_routine_physical_in_the_past_3_years"
            )?.value,
          Do_you_have_any_allergies_or_sensitivities_to_Sermorelin: getItem(
            "Do_you_have_any_allergies_or_sensitivities_to_Sermorelin"
          )?.value,
          Do_you_have_untreated_hypothyroidism: getItem("Do_you_have_untreated_hypothyroidism")?.value,
          Do_you_have_existing_uncontrolled_diabetes_with_a_hemoglobin_A1C_greater_than_9_percent: getItem("Do_you_have_existing_uncontrolled_diabetes_with_a_hemoglobin_A1C_greater_than_9%")?.value,
          Do_you_use_opiate_medications_routinely_or_binge_drink_alcohol: getItem("Do_you_use_opiate_medications_routinely_or_binge_drink_alcohol")?.value,
          What_are_your_primary_goals_for_seeking_treatment: getItem(
            "primary_goal"
          )?.otherText
            ? getItem("primary_goal")?.otherText
            : getItem("primary_goal")?.value,

          Please_list_your_current_medications_prescription_and_over_the_counter_and_supplements:
            getItem(
              "Please_list_your_current_medications_prescription_and_over_the_counter_and_supplements"
            )?.currentMedications
              ? getItem(
                  "Please_list_your_current_medications_prescription_and_over_the_counter_and_supplements"
                )?.currentMedications
              : getItem(
                  "Please_list_your_current_medications_prescription_and_over_the_counter_and_supplements"
                )?.value,
          Do_you_have_any_one_of_the_following_medical_conditions: getItem(
            "Do_you_have_any_one_of_the_following_medical_conditions"
          )?.medicalConditions
            ? getItem("Do_you_have_any_one_of_the_following_medical_conditions")
                ?.medicalConditions
            : getItem("Do_you_have_any_one_of_the_following_medical_conditions")
                ?.value,
        };
      });
    };

    retrieveLocalStorageData();
  }, [formState, actualWeight, height, dob, gender, uuidValue]);


  const getProducts = useCallback(async () => {
    const productId = "sermorelin";

    setPricingData([]);

    try {
      const response = await getStripeProducts(productId);
      const defaultDiscount = response?.default_discount || 0; 

      if (response?.data?.length) {
        let recurringProducts = response.data.filter(
          (product: Product) => product.active && product.type === "recurring"
        );

        recurringProducts = recurringProducts.map((product: Product) => ({
          ...product,
          unit_amount: product.unit_amount - defaultDiscount * 100,
        }));

        setPricingData(recurringProducts);
        if (recurringProducts.length > 0) {
          const calculatedBasePrice = recurringProducts[0]?.unit_amount / 100;
          setBasePriceAfterDefaultDiscount(calculatedBasePrice);
          setFinalAmount(calculatedBasePrice);
        }
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }, []);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  const handleStripeReady = (
    stripe: Stripe | null,
    elements: StripeElements | null
  ) => {
    setStripeInstance(stripe);
    setElementsInstance(elements);
  };

  const nextChargeDate = new Date();
  nextChargeDate.setMonth(nextChargeDate.getMonth() + 1); // Add 1 month
  const formattedDate = nextChargeDate.toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
  });

  const openSiteLock = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.open(
      "https://www.sitelock.com/verify.php?site=claya.com",
      "SiteLock",
      "width=600,height=600,left=160,top=170"
    );
  };

  const handleChange = (field: string, value: string) => {
    setFormState((prev) => {
      const updatedState = { ...prev, [field]: value };
      const errors: Partial<typeof prev> = {};

      const isEmpty = (val: string) => val.trim() === "";

      switch (field) {
        case "firstName":
          errors.firstNameError = isEmpty(value)
            ? "Please enter your first name"
            : "";
          break;
        case "lastName":
          errors.lastNameError = isEmpty(value)
            ? "Please enter your last name"
            : "";
          break;
        case "email":
          errors.emailError = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
            ? "Please enter a valid email"
            : "";
          break;
        case "phone":
          if (value.replace(/\D/g, "").length > 10) return prev;
          errors.phoneError =
            value.replace(/\D/g, "").length !== 10
              ? "Please enter a valid 10-digit phone number"
              : "";
          updatedState.phone = formatPhoneNumber(value);
          break;
        case "addressLine1":
          errors.addressLine1Error = isEmpty(value)
            ? "Please enter your Address Line 1"
            : "";
          break;
        case "city":
          errors.cityError = isEmpty(value) ? "Please enter your city" : "";
          break;
        case "state":{
          const upperState = value.toUpperCase();
          updatedState.state = upperState;

          if (isEmpty(upperState)) {
            errors.stateError = "Please enter your state";
          } else if (
            ["AR"].includes(upperState)
          ) {
            const fullStateName = stateOptions[upperState]
            errors.stateError = `Sorry, currently we do not offer the medication in ${fullStateName}.`;
          } else {
            errors.stateError = "";
          }

          break;
        }
        case "zip":
          errors.zipError = isEmpty(value)
            ? "Please enter your zip code"
            : value.length > 5
            ? "Zip code cannot exceed 5 digits"
            : "";
          if (value.length > 5) return prev;
          break;
        case "billingAddressAddressLine1":
          errors.billingAddressAddressLine1Error = isEmpty(value)
            ? "Please enter your Address Line 1"
            : "";
          break;
        case "billingAddressCity":
          errors.billingAddressCityError = isEmpty(value)
            ? "Please enter your city"
            : "";
          break;
        case "billingAddressState":
          errors.billingAddressStateError = isEmpty(value)
            ? "Please enter your state"
            : "";
          break;
        case "billingAddressZip":
          errors.billingAddressZipError = isEmpty(value)
            ? "Please enter your zip"
            : value.length > 5
            ? "Zip code cannot exceed 5 digits"
            : "";
          if (value.length > 5) return prev;
          break;
        case "isSubscribed":
          updatedState.isSubscribed = Boolean(value);
          break;

        case "isCheckedTerms":
          updatedState.isCheckedTerms = Boolean(value);
          break;
        default:
          break;
      }

      return {
        ...updatedState,
        ...errors,
      };
    });
  };

  const toggleCouponInput = () => {
    setShowCouponInput((prev) => !prev);
  };

  const handleCardNumberChange = (event: { complete: boolean }) => {
    setIsCardNumberValid(event.complete);
  };

  const handleCardExpiryChange = (event: { complete: boolean }) => {
    setIsCardExpiryValid(event.complete);
  };

  const handleCardCvcChange = (event: { complete: boolean }) => {
    setIsCardCvcValid(event.complete);
  };

  const handleChangeState = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    handleChange("state", value);
  };

  const handleChangeBillingState = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = e.target.value;
    handleChange("billingAddressState", value);
  };

  const stateOptions: Record<string, string> = {
    AK: "Alaska",
    AL: "Alabama",
    AR: "Arkansas",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming",
  };

  const handleCheckboxChange = () => {
    setFormState((prev) => {
      const isCheckedNow = !prev.isChecked;

      return {
        ...prev,
        isChecked: isCheckedNow,
        ...(isCheckedNow
          ? {
              billingAddressAddressLine1: "",
              billingAddressAddressLine2: "",
              billingAddressCity: "",
              billingAddressState: "",
              billingAddressZip: "",
            }
          : {
              billingAddressAddressLine1: prev.addressLine1,
              billingAddressAddressLine2: prev.addressLine2,
              billingAddressCity: prev.city,
              billingAddressState: prev.state,
              billingAddressZip: prev.zip,
            }),
      };
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormState((prev) => ({ ...prev, loading: true, error: "" }));

    const syncStates = ["DC", "DE", "MS", "NM", "RI", "WV"];

    if (!stripeInstance || !elementsInstance) {
      setFormState((prev) => ({
        ...prev,
        error: "Stripe is not ready. Please refresh the page.",
        loading: false,
      }));
      return;
    }

    const cardNumberElement = elementsInstance.getElement(CardNumberElement);
    if (!cardNumberElement) {
      setFormState((prev) => ({
        ...prev,
        error: "Card number element not found.",
        loading: false,
      }));
      return;
    }

    try {
      const { paymentMethod, error } = await stripeInstance.createPaymentMethod(
        {
          type: "card",
          card: cardNumberElement,
          billing_details: {
            email: formState.email,
            name: `${formState.firstName} ${formState.lastName}`,
          },
        }
      );

      if (error) {
        throw new Error(error.message || "Payment method creation failed.");
      }

      const URL = isProd
        ? "https://claya-ruby-b715fff96163.herokuapp.com"
        : "https://claya-stage-ruby-03e61b6e8c6b.herokuapp.com";

      const priceId = pricingData[0]?.id;
      const planType = "1 month";

      if (!priceId) {
        throw new Error("Product price ID not found.");
      }

      localStorage.setItem("priceId", priceId);
      localStorage.setItem("planPrice", String(finalAmount) || "");
      localStorage.setItem("itemName", "Sermorelin");

      const [month, day, year] = dob.split("/");
      const formattedDobForApi = `${month}/${day}/${year}`;

      const productCategory = "sermorelin"

      try {
        const updatePatientResponse = await updateExistingPatient(
          formState.email,
          formattedDobForApi,
          gender,
          height,
          actualWeight,
          formState.city,
          formState.addressLine1,
          formState.addressLine2,
          formState.state,
          formState.zip,
          formState.phone,
          productCategory,
          uuidValue
        );
        console.log(updatePatientResponse?.message);
      } catch (err: unknown) {
        setFormState((prev) => ({
          ...prev,
          error:
            err instanceof Error
              ? err.message
              : "Something went wrong while updating patient information.",
        }));
        return;
      }

      const intakeQuestionForm = await submitIntakeForm(
        {
          ...formData,
        },
        formData.email,
        productCategory,
        uuidValue
      );

      console.log(intakeQuestionForm);

      const product_name = "Sermorelin";

      const createSubRes = await fetch(
        `${URL}/api/v1/patients/payments/create_subscription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: formState.email,
            first_name: formState.firstName,
            last_name: formState.lastName,
            payment_method_id: paymentMethod.id,
            price_id: priceId,
            product_name: product_name,
            uuid: uuidValue,
          }),
        }
      );

      const data = await createSubRes.json();
      if (!createSubRes.ok) {
        setFormState((prev) => ({
          ...prev,
          loading: false,
          error: data?.error || "Subscription creation failed.",
        }));
        return;
      }

      const { customer_id } = data;

      const email = formState.email;

      const response = await fetch(
        `${URL}/api/v1/patients/payments/update_and_capture_subscription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customer_id,
            base_price_id: priceId,
            planType,
            product_name,
            email,
            promo_code: couponCode,
            uuid: uuidValue,
          }),
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        console.error("API Error:", responseData);
        throw new Error(
          responseData?.error ||
            `Network error: ${response.status} - Unknown error`
        );
      }else{
        const  transactionID = responseData['transaction_id'];
        pushPurchaseEvent(product_name, "Injectables", String(finalAmount), planType, transactionID )
        everflowConversion();
        localStorage.setItem(
          "success_transaction",
          JSON.stringify({ key: "success_transaction", value: responseData["success"] })
        );
      }

      // Check for sync states and redirect accordingly
      const userState = formState.state?.toUpperCase(); // Ensure comparison is case-insensitive

      if (syncStates.includes(userState)) {
        navigate("/sermorelin/getting-started/step-15");
      } else {
        navigate("/sermorelin/thank-you");
      }
      
      localStorage.setItem("completed-step-14", "true");
    } catch (err: any) {
      console.error("Checkout error:", err);
      setFormState((prev) => ({
        ...prev,
        error: err.message || "Something went wrong during checkout.",
      }));
    } finally {
      setFormState((prev) => ({ ...prev, loading: false }));
    }
  };

  const applyCoupon = async () => {
    if (
      couponCode &&
      !showDiscountlabel &&
      basePriceAfterDefaultDiscount !== null
    ) {
      try {
        setLoading1(true);
        const productId = pricingData[0]?.product;
        const response = await validateCoupon(
          couponCode,
          basePriceAfterDefaultDiscount,
          productId
        );
        if (response.valid) {
          setIsCouponApplied(true);
          setFinalAmount(basePriceAfterDefaultDiscount - response?.discount);
          setShowDiscountLabel(true);
          setWrongCoupon(false);
          setCouponDiscountValue(response?.discount);
        } else {
          setWrongCoupon(true);
        }
      } catch (error) {
        console.error("Error validating coupon:", error);
        setWrongCoupon(true);
      } finally {
        setLoading1(false);
      }
    }
  };

  const removeCoupon = () => {
    setIsCouponApplied(false);
    setCouponCode("");
    localStorage.setItem("promoCode", "");
    setFinalAmount(basePriceAfterDefaultDiscount);
    setCouponDiscountValue(null);
    setShowDiscountLabel(false);
  };

  const handleCouponCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode(e.target.value);
    setWrongCoupon(false);
  };

  const benefits = [
    { icon: AntiAging, text: "Anti - aging" },
    { icon: ClearBrain, text: "Clear brain fog" },
    { icon: ImproveMentalClarity, text: "Improve mental clarity" },
    { icon: MetabolicFunction, text: "metabolic function" },
    { icon: BoostEnergy, text: "Boost energy" },
    { icon: MemoryConcentration, text: "Memory & concentration" },
    { icon: ImproveAthletic, text: "Improve athletic performance" },
  ];

  const NADBenefits = () => {
    return (
      <div className="nad-section">
        <h2 className="nad-title">Sermorelin helps with</h2>
        <div className="benefits-grid">
          {benefits.map((item, index) => (
            <div key={index} className="benefit-item">
              <img src={item.icon} alt={item.text} className="benefit-icon" />
              <p className="benefit-text">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const handleBack = () => {
    navigate("/nadplus/getting-started/step-12");
  };

  return (
    <PageWrapper>
      <div className="signup-page-container">
        {/* <ProgressBar progress={100} onBack={handleBack} />  */}
        <div className="checkout-container">
          <div className="nad-checkout-container">
            <div className="nad-checkout-content">
              <img
                src={NadPlusNasalInjectables}
                className="nad-checkout-image"
                alt={"sermorelin injectables"}
              />
              <div className="nad-checkout-details">
                <h3 className="nad-checkout-title">Sermorelin Injectables</h3>
                <p className="nad-checkout-subtext">
                  A convenient way to boost brain Sermorelin levels, formulated to
                  help improve energy clarity, and mood as needed
                </p>
              </div>
            </div>
            <div className="nad-content-divider" />
            <div className="nad-checkout-inclusions">
              <h4 className="inclusions-title">Inclusions</h4>
              <div className="inclusion-row">
                <span className="inclusion-product-name">
                  Sermorelin Injectables
                </span>
                {pricingData && pricingData[0] ? (
                  <span>
                    ${(pricingData[0]?.unit_amount / 100).toFixed(2) || 0}
                  </span>
                ) : (
                  <div className="loader"></div>
                )}
              </div>
              <div className="inclusion-row">
                <span>Provider Evaluation</span>
                <span>Free</span>
              </div>
              <div className="inclusion-row">
                <span>Ongoing check-ins</span>
                <span>Included</span>
              </div>
              <div className="inclusion-row">
                <span>Shipping</span>
                <span>Free</span>
              </div>
            </div>
            <div className="total-row-price-details">
              <div className="total-row">
                <span className="total-label">
                  TOTAL <span className="total-note">(Due now)</span>
                </span>
                <span className="total-amount">
                  ${(finalAmount || 0).toFixed(2)}
                </span>
              </div>

              <p className="refund-note">
                (If not prescribed, your refund will be processed within 3
                business days)
              </p>
            </div>
            <div className="coupon-toggle-container">
              <div className="coupon-toggle-header" onClick={toggleCouponInput}>
                <span className="coupon-text">Apply promo code</span>
              </div>

              {showCouponInput && (
                <div className="coupon-input-wrapper">
                  <input
                    type="text"
                    value={isCouponApplied === true ? "" : couponCode}
                    onChange={handleCouponCodeChange}
                    placeholder="Discount Code or gift card"
                    className="coupon-input"
                  />
                  <button
                    disabled={loading1 || showDiscountlabel}
                    type="button"
                    onClick={applyCoupon}
                    className="apply-coupon-btn"
                    style={{
                      backgroundColor: showDiscountlabel
                        ? "#0C3972"
                        : "#E5EDF6",
                      color: showDiscountlabel ? "#fff" : "#000",
                    }}
                  >
                    {showDiscountlabel ? "Applied" : "Apply"}
                  </button>
                </div>
              )}
              {showDiscountlabel && couponDiscountValue !== null && (
                <div className="applied-coupon">
                  <img
                    src={couponImage}
                    alt="Coupon Icon"
                    style={{ width: "13px", height: "12.48px" }}
                  />
                  <span style={{ fontSize: "12px" }}>Coupon Applied</span>
                  <button
                    type="button"
                    onClick={removeCoupon}
                    className="remove-coupon-btn"
                  >
                    X
                  </button>
                </div>
              )}
              {wrongCoupon && (
                <p className="error-message" style={{ textAlign: "left" }}>
                  Invalid coupon code. Please try again.
                </p>
              )}
            </div>
          </div>
          <div className="next-charge-per-month" style={{ paddingTop: "15px" }}>
            <span className="next-charge-per-month-styling">
              Next charge on {formattedDate} :
            </span>
            <span className="next-charge-per-month-styling">
              ${basePriceAfterDefaultDiscount}{" "}
              {/* Next charge will be the full final amount */}
            </span>
          </div>

          <div className="payment-section">
            <CheckoutFormWrapper
              stripePromise={stripePromise}
              onStripeReady={handleStripeReady}
              {...formState}
              onChange={handleChange}
              onSubmit={handleSubmit}
              onCardNumberChange={handleCardNumberChange}
              onCardExpiryChange={handleCardExpiryChange}
              onCardCvcChange={handleCardCvcChange}
              isCardValid={isCardValid}
              handleChangeState={handleChangeState}
              handleChangeBillingState={handleChangeBillingState}
              onCheckboxChange={handleCheckboxChange}
              stateOptions={stateOptions}
              nadPlusProduct={true}
            />
          </div>
        </div>
        <div style={{ width: "100%" }}>{NADBenefits()}</div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "20px 0px",
          }}
        >
          <a href="#" onClick={openSiteLock}>
            <img
              className="img-fluid"
              alt="SiteLock"
              title="SiteLock"
              src="https://shield.sitelock.com/shield/claya.com"
            />
          </a>
        </div>
        <div className="help-box help-box-container">
          <div className="help-text-ele">
            <h2 className="help-font">Need Help?</h2>
            <div className="adjust-dot-text">
              <div className="dot">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <circle cx="9" cy="9.63965" r="6" fill="#00B57A" />
                  <circle
                    cx="9"
                    cy="9.63965"
                    r="7.5"
                    stroke="#00B57A"
                    strokeOpacity="0.15"
                    strokeWidth="3"
                  />
                </svg>
              </div>
              <span className="available-text">
                Available{" "}
                <span className="available-timings">8 AM – 8 PM ET</span>
              </span>
            </div>
          </div>
          <div></div>
          <div className="contact-ele">
            <div className="phone-img">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
              >
                <g clipPath="url(#clip0_1419_1009)">
                  <path
                    d="M8.20312 0.139821C11.9561 0.139821 15 3.18377 15 6.93669C15 7.32634 14.6865 7.63982 14.2969 7.63982C13.9072 7.63982 13.5938 7.32634 13.5938 6.93669C13.5938 3.96013 11.1797 1.54607 8.20312 1.54607C7.81348 1.54607 7.5 1.23259 7.5 0.842946C7.5 0.453297 7.81348 0.139821 8.20312 0.139821ZM8.4375 5.76482C8.95518 5.76482 9.375 6.18464 9.375 6.70232C9.375 7.22 8.95518 7.63982 8.4375 7.63982C7.91982 7.63982 7.5 7.22 7.5 6.70232C7.5 6.18464 7.91982 5.76482 8.4375 5.76482ZM7.5 3.65544C7.5 3.2658 7.81348 2.95232 8.20312 2.95232C10.4033 2.95232 12.1875 4.7365 12.1875 6.93669C12.1875 7.32634 11.874 7.63982 11.4844 7.63982C11.0947 7.63982 10.7812 7.32634 10.7812 6.93669C10.7812 5.51287 9.62695 4.35857 8.20312 4.35857C7.81348 4.35857 7.5 4.04509 7.5 3.65544ZM3.44238 0.180836C4.01074 0.0255629 4.60547 0.315602 4.83105 0.860524L6.00293 3.67302C6.20215 4.15056 6.06445 4.70427 5.66309 5.02947L4.21875 6.21306C5.19434 8.27556 6.86426 9.94548 8.92676 10.9211L10.1074 9.47673C10.4355 9.07537 10.9863 8.93767 11.4639 9.13689L14.2764 10.3088C14.8213 10.5343 15.1113 11.1291 14.9561 11.6974L14.2529 14.2756C14.1152 14.7853 13.6523 15.1398 13.125 15.1398C5.87695 15.1398 0 9.26287 0 2.01482C0 1.48748 0.354492 1.02459 0.864258 0.883961L3.44238 0.180836Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1419_1009">
                    <rect
                      width="15"
                      height="15.0006"
                      fill="white"
                      transform="translate(0 0.139404)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h2 className="phone-number">+1 (415) 980-4031</h2>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SermorelinPage14;
